import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { AuthService } from '@/auth/services';

export const guestGuard: CanActivateFn = (): Observable<boolean> => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.user) {
        router.navigate(['/']).then();
        return of(false);
    }
    return of(true);
};
